import React from 'react'
import { PropTypes } from 'prop-types';
import { getContractSummary } from '../../action/contract/getContractSummary';
import { connect } from 'react-redux';
import withRouter from '../../withRouter';
export class HeroSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contractSummary: '',
            userName: this.props.userName
        }
    }

    componentDidMount() {
        let details = sessionStorage.getItem('contractSummary');
        if (!details) {
            this.getUserContractDetails();
        }
        let contractSummaryResult = this.props.contractSummary ? this.props.contractSummary : JSON.parse(details);
        console.log(contractSummaryResult);

        this.setState({ contractSummary: contractSummaryResult });
        console.log(this.state.contractSummary);
    }

    async getUserContractDetails() {
        if ((localStorage.getItem('fromWhere') != 'apply_now' && sessionStorage.getItem('fromWhere') != 'apply_now') && localStorage.getItem('sessionId') !== null) {
            const contractSummaryResult = await getContractSummary({ email: localStorage.getItem('email') });
            this.updateUserContractDetails(contractSummaryResult);
        }
    }

    updateUserContractDetails(contractSummaryResult) {
        let summary = '';
        if (contractSummaryResult !== undefined) {
            if (contractSummaryResult.status === 200) {
                for (const [key, value] of Object.entries(contractSummaryResult.data)) {
                    if (key === "data") {
                        summary = value;
                    }
                }
                this.props.getContractSummaryDetails(summary);
            }
        }
    }


    render() {
        let details = this.props.contractSummary || JSON.parse(sessionStorage.getItem('contractSummary'));
        let userName = this.props.userName || sessionStorage.getItem('UserName') || '';
        console.log(details);
        return (

            <div className="row">
            <div className="col-12">
                <div className="wallet---itemQr">
                    <div className="wallet-container w-100 wallet--banner-img">
                        <div className="lr-item--hero">
                            <div className="hero-left">
                                <div className="hero-left-top">
                                    <div className="col-lg-4 col-md-4 user-info">
                                        <div className="user-image-area">
                                            {this.props.profilePicture!=='' && this.props.profilePicture!==null &&
                                            <img src={this.props.profilePicture}  className="img-fluid" alt="User"/>}
                                            {this.props.profilePicture ===null &&
                                            <div className="no-profile-image">
                                            {userName!='' && userName!==null &&
                                              <span className="no-profile-image-letter-wallet">{userName.charAt(0).toUpperCase()}</span>
                                            }
                                            </div>
                                            }
                                        </div>
                                        <span>
                                            {userName!=='' && userName!==null &&
                                            <h6 className="wallet-user-name">Hi {userName}!</h6>}
                                            {!userName &&
                                            <h6>Hi!</h6>}
                                        </span>
                                    </div>

                                       <div className="col-lg-8 col-md-8 pr-5 user-expense wallet-active-item">
                                            <div className="d-flex">
                                                <div className="total-to-spend">
                                                    <h6>Total To Spend</h6>
                                                  
                                                {details !== null && details.total_amount !== undefined && details.total_amount !== 0 &&
                                                <h2>£{details.total_amount}</h2>
                                                }
                                                 {details !== null && details.total_amount == undefined &&
                                                <h2>£0.00</h2>
                                                }
                                                 {details === null &&
                                                <h2>£0.00</h2>
                                                }
                                                    
                                                    {/* <h2>£{details.total_amount == null ? '0.00':'0.00'}</h2> */}
                                                </div>
                                                <div className="total-to-spend ml-4">
                                                    <h6>Total Outstanding</h6>
                                                    
                                                    <h2>£{details !== null ? details.total_outstanding : '0.00'}</h2>
                                                </div>
                                            </div>
                                            <div className="next-payment">
                                                <h6>Next payment</h6>
                                                {details !== null && details.next_payment_amount !== undefined && details.next_payment_amount !== '' && details.next_payment_amount !== 0 &&
                                                    <h2>£{details.next_payment_amount}</h2>
                                                }
                                                {details !== null && details.next_payment_amount == undefined &&
                                                    <h2>£0.00</h2>
                                                }
                                                {details !== null && details.next_payment_amount == ''  && details.next_payment_amount == 0 &&
                                                    <h2>£0.00</h2>
                                                }
                                                {details == null  &&
                                                    <h2>£0.00</h2>
                                                }

                                                    {/* <h2>£{details !== null?details.next_payment_amount:'0.00'}</h2> */}
                                                    {details !== null && details.next_payment_date !== undefined &&
                                                    <span>{details.next_payment_date || ''}</span>
                                                    // <h2>£{details.next_payment_amount}</h2>
                                                    }
                                                    {details !== null && details.next_payment_date == undefined &&
                                                    <span>{details.next_payment_date || ''}</span>
                                                    }
                                                    {details !== null && details.next_payment_date == '' &&
                                                    <span>{details.next_payment_date || ''}</span>
                                                    }
                                                {/* <span>{details !== null ?details.next_payment_date:''}</span> */}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HeroSection.propTypes = {
    contractSummary: PropTypes.string,
    profilePicture: PropTypes.string,
}
 
const mapStateToProps = (state) => ({
    contractSummary: state.dataStore.contractSummary,
});

export const mapDispatchToProps = (dispatch) => {
    return {
        getContractSummaryDetails: (summary) => {
            return dispatch({
                type: 'SET_CONTRACT_SUMMARY',
                value: summary
            });
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeroSection));
